export enum AccountProductStatus {
    discontinued = 'discontinued',
    outOfStock = 'outOfStock',
    addToCartSTH = 'addToCartSTH',
    addToCartInStore = 'addToCartInStore',
    addToCartRedirectPDP = 'addToCartRedirectPDP',
}

export interface AccountProductPrice {
    currencyCode: string;
    centAmount: number;
    fractionDigits: number;
}

export interface AccountProduct {
    productKey: string;
    productSlug: string;
    sku: string;
    storeId?: string | null;
    name: string;
    descriptionShort: string;
    descriptionLong: string;
    isDiscontinued: boolean;
    primaryCategoryId: string;
    url: string;
    images: {
        large?: string;
        small?: string;
    };
    listPrice?: AccountProductPrice;
    basePrice?: AccountProductPrice;
    status: AccountProductStatus;
    brand: string;
    category: string;
    subCategory1: string;
    subCategory2: string;
    pharmacyType: string;
    color?: string;
    size?: string;
    flavor?: string;
    customCaseQuantity?: number;
    bopisCaseQty?: number;
    isCaseRequired?: boolean;
    vicePresidentName?: string;
    hierarchyDivision?: string;
    hierarchyDepartment?: string;
    hierarchyClass?: string;
    hierarchyCategory?: string;
}
